import React, { useState } from "react";
import { Box, Flex, Text, TextButton } from "@catchoftheday/cg-components";
import { formatCreditCardNumber } from "@catchoftheday/utilities";
import { CREDIT_CARD_REMOVAL_CONFIRMATION_PROMPT } from "../../../../consts/index.js";
import { PaymentMethod } from "../../PaymentMethod/PaymentMethod.jsx";
import { SavedCardRemovalModal } from "../SavedCardRemovalModal/SavedCardRemovalModal.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SavedCard = function SavedCard(_ref) {
  var formattedLabel = _ref.formattedLabel,
      name = _ref.name,
      icon = _ref.icon,
      cardExpiry = _ref.cardExpiry,
      cardMaskedNumber = _ref.cardMaskedNumber,
      onUpdate = _ref.onUpdate,
      onRemove = _ref.onRemove;
  var displayUpdateButton = typeof onUpdate === "function";
  var isRemovable = typeof onRemove === "function";

  var _useState = useState(false),
      displayCardRemovalModal = _useState[0],
      setDisplayCardRemovalModal = _useState[1];

  return ___EmotionJSX(Box, {
    maxWidth: "480px",
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gridAutoRows: "1fr",
    alignItems: "center",
    columnGap: 4
  }, ___EmotionJSX(PaymentMethod, {
    icon: icon,
    label: ___EmotionJSX(Flex, {
      flexDirection: "column"
    }, ___EmotionJSX(Text, {
      m: 0
    }, formattedLabel), cardExpiry && ___EmotionJSX(Text, {
      m: 0,
      fontWeight: "medium",
      color: "textTertiary"
    }, "Expiry: ".concat(cardExpiry)))
  }), ___EmotionJSX(Flex, {
    justifyContent: "flex-end"
  }, displayUpdateButton && ___EmotionJSX(TextButton, {
    onClick: onUpdate
  }, "Update"), isRemovable && ___EmotionJSX(TextButton, {
    onClick: function onClick() {
      return setDisplayCardRemovalModal(true);
    },
    ml: 4
  }, "Remove")), isRemovable && name && cardMaskedNumber && ___EmotionJSX(SavedCardRemovalModal, {
    isOpen: displayCardRemovalModal,
    heading: "Remove ".concat(name, " ending in ").concat(formatCreditCardNumber(cardMaskedNumber, "")),
    prompt: CREDIT_CARD_REMOVAL_CONFIRMATION_PROMPT,
    onClose: function onClose() {
      return setDisplayCardRemovalModal(false);
    },
    onConfirm: function onConfirm() {
      return onRemove();
    }
  }));
};